import { useState } from 'react';
import { Badge, Button, Modal } from 'react-bootstrap';
import { useMqttSniffer } from '../../hooks/useMqttSniffer';

export const UnitMqttSniffer = ({ unitId }) => {
  const [showSnifferModal, setShowSnifferModal] = useState(false);

  const { messages, isConnected, reset } = useMqttSniffer(unitId, showSnifferModal);

  const handleOpen = () => {
    reset();
    setShowSnifferModal(true);
  };

  const handleClose = () => {
    setShowSnifferModal(false);
    reset();
  };

  return (
    <>
      <Button
        variant="info"
        className="mqtt-button w-100"
        style={{ color: 'black' }}
        onClick={handleOpen}
      >
        MQTT Sniffer
      </Button>

      <Modal show={showSnifferModal} onHide={handleClose} size="lg" scrollable>
        <Modal.Header closeButton>
          <Modal.Title>
            MQTT Sniffer — Unit {unitId}{' '}
            <Badge bg={isConnected ? 'success' : 'secondary'}>
              {isConnected ? 'Connected' : 'Connecting…'}
            </Badge>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {messages.length === 0 ? (
            <div className="text-center text-muted py-4">
              Waiting for messages on {unitId}/#…
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm table-striped">
                <thead>
                  <tr>
                    <th>Time</th>
                    <th>Topic</th>
                    <th>Payload</th>
                  </tr>
                </thead>
                <tbody>
                  {messages.map((msg, index) => (
                    <tr key={`${msg.timestamp}-${index}`}>
                      <td style={{ whiteSpace: 'nowrap' }}>
                        {new Date(msg.timestamp).toLocaleTimeString()}
                      </td>
                      <td style={{ wordBreak: 'break-all' }}>{msg.topic}</td>
                      <td style={{ wordBreak: 'break-all' }}>{msg.payload}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={reset}>
            Clear
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
